/* LES REFERENCES DE L'ORDRE DE DEPENSE.

   Le document s'imprime depuis deux sources selon l'ecran : l'onglet des reglements
   d'un sinistre lui passe le reglement ET le sinistre complet ; le detail d'un lot de
   reglements aux experts n'a que le paiement, et passait `sinistre={null}`.

   Les chaines de repli qui en resultaient etaient ecrites a la main dans le JSX, et
   deux d'entre elles ne pouvaient pas aboutir :

   - `reglement.sinistreNumero` n'existe sur aucune reponse du serveur. `PaiementResponse`
     comme `PaiementDetailResponse` envoient `sinistreReference`. Le repli etait donc
     mort, et sur un ordre de depense de lot - ou le sinistre est absent - toute la
     chaine l'etait avec lui : le document sortait sans numero de sinistre.

   - la date de survenance ne se lisait que sur le sinistre. Sans sinistre, la ligne
     « Survenu le » sortait vide sur tous les ordres de depense d'un lot.

   En JavaScript, lire un champ absent ne leve rien : il rend `undefined`, le repli
   suivant prend la main, et le dernier rend la chaine vide. Aucune erreur, aucun
   avertissement - seulement un document incomplet. D'ou ce fichier, et ses tests. */

/**
 * Le numero du sinistre, tel qu'il doit paraitre sur la piece.
 *
 * <p>Le numero de l'assureur prime quand le sinistre est connu : c'est la reference que
 * la compagnie reconnaitra. Vient ensuite la reference calculee par le serveur, seule
 * disponible quand le document s'imprime depuis un paiement.
 */
export function numeroSinistreDuDocument(reglement, sinistre) {
    return (
        sinistre?.numeroSinistreAssureur ||
        reglement?.sinistreReference ||
        sinistre?.numeroSinistreLocal ||
        sinistre?.numeroSinistreManuel ||
        sinistre?.numeroSinistreHomologue ||
        ''
    );
}

/**
 * La date de survenance du sinistre.
 *
 * <p>`dateAccident` est le nom porte par `SinistreResponse` ; `dateSinistre` celui que
 * `PaiementResponse` porte depuis que le document doit s'imprimer sans le sinistre.
 */
export function dateSurvenanceDuDocument(reglement, sinistre) {
    return (
        sinistre?.dateAccident ||
        sinistre?.dateSinistre ||
        reglement?.dateSinistre ||
        null
    );
}

/**
 * L'organisme dont le document porte l'en-tete, le pied de page et les signataires.
 *
 * <p>LE BUREAU CARTE BRUNE, ET NON L'ASSUREUR DU DOSSIER. `organisme` est l'organisme
 * membre du sinistre - une compagnie d'assurance. Les pieces sortaient a son nom tant
 * que `bureau` n'etait pas fourni. Il reste le repli : mieux vaut un en-tete imparfait
 * qu'un document sans en-tete du tout.
 */
export function bureauDuDocument({ bureau, organisme, sinistre } = {}) {
    return bureau || organisme || sinistre?.contrat?.organisme || {};
}

/**
 * La victime pour laquelle la depense est engagee.
 *
 * <p>L'ordre de depense d'honoraires d'expert est paye A L'EXPERT - c'est lui qu'on
 * regle - mais il doit dire pour quelle victime l'expertise a ete faite. Un sinistre en
 * porte souvent plusieurs : la victime pertinente est celle de l'expertise qui justifie
 * les honoraires, et c'est le serveur qui la resout.
 *
 * <p>Rend la chaine vide quand aucune victime n'est rattachee : le document omet alors
 * la ligne, plutot que d'afficher un tiret qui laisserait croire a une donnee manquante.
 */
export function victimeDuDocument(reglement) {
    return reglement?.victimeNom || reglement?.beneficiaireDetail?.nom || '';
}
